var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingUnchanged = function SvgTrendingUnchanged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 6.02H0v-.75h10.57L8.83 3.53 9.35 3l2.4 2.38.25.27L9.35 8.3l-.52-.54 1.74-1.74z",
    fillRule: "evenodd"
  })));
};
export default SvgTrendingUnchanged;